export default __webpack_public_path__ + "static/media/desktop.1e2e6e50.jpg";